<script setup lang="ts">
import { ElTag } from 'element-plus'
import TwoRowCell from './TwoRowCell.vue'
import type { AppointmentTableRow } from './types'

const props = defineProps<{
  rowData: AppointmentTableRow
}>()

const appointmentWithInfo = computed(() => {
  return props.rowData.transaction?.outbound_appointment
})

const daysToLFD = computed(() => {
  if (!appointmentWithInfo.value) return undefined
  const lfd =
    appointmentWithInfo.value.watch.import_last_free_date?.startOf('day')
  if (!lfd) return undefined
  const appointmentShiftDate =
    appointmentWithInfo.value.appointment.shiftDate.startOf('day')
  return lfd.diff(appointmentShiftDate, 'days').days
})
const lfdDescription = computed(() => {
  if (appointmentWithInfo.value?.watch.import_last_free_date) {
    return appointmentWithInfo.value?.watch.import_last_free_date.toFormat(
      'M/d'
    )
  }
})

const daysToLFDDescription = computed(() => {
  let dayNoun = 'days'
  if (daysToLFD.value === undefined) return '???'
  if (Math.abs(daysToLFD.value) === 1) dayNoun = 'day'
  return `${daysToLFD.value} ${dayNoun}`
})
const tagType = computed(() => {
  if (daysToLFD.value === undefined) return 'info'
  if (daysToLFD.value > 0) return 'success'
  if (daysToLFD.value === 0) return 'warning'
  return 'danger'
})
const tooltip = computed(() => {
  if (daysToLFD.value === undefined) return undefined
  let dayNoun = 'days'
  const absDaysToLFD = Math.abs(daysToLFD.value)
  if (absDaysToLFD === 1) dayNoun = 'day'
  if (daysToLFD.value > 0)
    return `Appointment is ${absDaysToLFD} ${dayNoun} before LFD`
  if (daysToLFD.value === 0) return 'Appointment is on LFD'
  return `Appointment is ${absDaysToLFD} ${dayNoun} after LFD`
})
</script>

<template>
  <TwoRowCell v-if="lfdDescription" v-tooltip="tooltip">
    <ElTag
      :type="tagType"
      size="small"
      class="mt-2px text-center"
      round
      :disable-transitions="true"
    >
      <span class="lfd-tag-text">{{ daysToLFDDescription }}</span>
    </ElTag>
    <template #secondary-row>
      <div class="lfd-description-text text-center">
        {{ lfdDescription }}
      </div>
    </template>
  </TwoRowCell>
</template>

<style scoped>
/* Override TwoRowCell font sizes */
:deep(.primary-row) {
  font-size: unset !important;
}
:deep(.secondary-row) {
  font-size: unset !important;
}

.lfd-tag-text {
  font-size: x-small;
}

.lfd-description-text {
  font-size: xx-small;
}
</style>
